export interface IVoucherHolderForList {
    id: number,
    firstName: string,
    lastName: string,
    birthDate: string,
    statusId: number,
    status: string,
    donorId: number,
    donorAlias: string,
    donorCenterId: number,
    donorCenterAlias: string,
    donorDonationDateTime: string,
    donorDonated: boolean,
    recipientId: number,
    recipientAlias: string,
    recipientCenterId: number,
    recipientCenterAlias: string,
    createdDateTime: string,
    adpInformedConsentFile: string,
    hlaSwabResultsFile: string,
    screeningResultsFile: string,
    swabsOrderedDateTime: string,
    lastScreeningOrderedDateTime: string
    dateAdded: string,
    typeId: number,
    type: string,
    recipientIdGenerated: number
}